import { render, staticRenderFns } from "./SobreCiudadesComunes.vue?vue&type=template&id=674d85b6&scoped=true"
import script from "./SobreCiudadesComunes.vue?vue&type=script&lang=js"
export * from "./SobreCiudadesComunes.vue?vue&type=script&lang=js"
import style0 from "./SobreCiudadesComunes.vue?vue&type=style&index=0&id=674d85b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d85b6",
  null
  
)

export default component.exports